
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { fetchCreditCardSettingsAPI, fetchOrderMinimumSettingsAPI, updateCreditCardSettingsAPI, updateOrderMinimumSettingsAPI } from "../apis/creditCardFee"

const initialState = {
    creditCardStatus: false,
    loading: false,
}


export const updateCreditCardSettings = createAsyncThunk(
    'notifications/updateCreditCardSettings',
    async (data, { rejectWithValue }) => {
        try {
            const res = await updateCreditCardSettingsAPI(data)
            return res
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)

export const fetchCreditCardSettings = createAsyncThunk(
    'notifications/fetchCreditCardSettings',
    async (data = {}, { rejectWithValue }) => {
        try {
            const res = await fetchCreditCardSettingsAPI(data)
            return res
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)


export const updateOrderMinimumSettings = createAsyncThunk(
    'notifications/updateOrderMinimumSettings',
    async (data, { rejectWithValue }) => {
        try {
            const res = await updateOrderMinimumSettingsAPI(data)
            return res
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)

export const fetchOrderMinimumSettings = createAsyncThunk(
    'notifications/fetchOrderMinimumSettings',
    async (data = {}, { rejectWithValue }) => {
        try {
            const res = await fetchOrderMinimumSettingsAPI(data)
            return res
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)

const shopSettingSlice = createSlice({
    name: 'shopSettings', // The name of the slice
    initialState, // The initial state of the products slice
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            .addCase(updateCreditCardSettings.pending, (state, action) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateCreditCardSettings.fulfilled, (state, action) => {
                state.loading = false;
                // You can update your state with the data received from the API if needed
            })
            .addCase(updateCreditCardSettings.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload; // The error message returned from the API
            });

        builder
            .addCase(fetchCreditCardSettings.pending, (state, action) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchCreditCardSettings.fulfilled, (state, action) => {
                state.loading = false;
                state.creditCardStatus = action.payload?.creditCardsettings
                // You can update your state with the data received from the API if needed
            })
            .addCase(fetchCreditCardSettings.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload; // The error message returned from the API
            });

    },

});

// Action creators generated by createSlice
export const {

} = shopSettingSlice.actions;

// Reducer function generated by createSlice
export default shopSettingSlice.reducer;